(() => {
    function scrollToPreviousProductPosition() {
        const searchParams = new URLSearchParams(window.location.search);
        const scrollPositionParam = searchParams.get('zp');
        if (scrollPositionParam) {
            const collectionContainer = document;
            let productElement = collectionContainer.querySelector(`[data-zoa-product-id='${scrollPositionParam}']`);
            if (!productElement) {
                productElement = collectionContainer.querySelector('.grid-item');
            }
            if (productElement) {
                productElement.scrollIntoView();
            } else {
                window.scrollTo(0, 0);
            }
            searchParams.delete('zp');
        }
        if (window.location.pathname === '/collections/vendors') {
            let brandFilter = null;
            brandFilter = searchParams.get('q');
            if (brandFilter) {
                searchParams.set('filter.p.vendor', brandFilter);
            }
        }
        searchParams.delete('phcursor');
        window.history.replaceState({}, '', `${window.location.pathname}?${searchParams}`);
    }

    function updateBrandFilterUrl() {
        const searchParams = new URLSearchParams(window.location.search);
        if (window.location.pathname === '/collections/vendors') {
            let brandFilter = null;
            brandFilter = searchParams.get('q');
            if (brandFilter) {
                searchParams.set('filter.p.vendor', brandFilter);
            }
        }
        searchParams.delete('phcursor');
        window.history.replaceState({}, '', `${window.location.pathname}?${searchParams}`);
    }

    updateBrandFilterUrl();
    document.addEventListener("DOMContentLoaded", function() {
        scrollToPreviousProductPosition();
    });
})();
